// graphql/oattinvoice.gql.ts

import { gql } from '@apollo/client';

export const GET_OATT_INVOICE = gql`
  query GetOattInvoice($month: Int!, $year: Int!, $customerId: Int) {
    getOattInvoice(month: $month, year: $year, customerId: $customerId) {
      invoice_id
      customer_id
      customer_code
      account_number
      billing_period
      line_items {
        invoice_data_id
        aref
        seller
        customer_code
        mw_granted
        total_charges_oatt
        total_charges_computed
        firm_transmission_charge
        nonfirm_transmission_charge
        ancillary_schedule1
        ancillary_schedule2
        total_charges
      }
      total_firm_transmission_charge
      total_nonfirm_transmission_charge
      total_ancillary_schedule1
      total_ancillary_schedule2
      oatt_charges_total
      hst
      hst_amount
      total_bill
      is_revision
      revision_no
      supersedes_invoice_id
      company_name
      address_line1
      address_line2
      address_line3
      misc_charge
      misc_comment
      is_approved
      revision_comment
      vendor_comment
    }
  }
`;

export const APPROVE_OATT_INVOICE = gql`
  mutation ApproveOattInvoice($invoiceId: Int!) {
    approveOattInvoice(invoiceId: $invoiceId) {
      success
      message
      invoice_id
    }
  }
`;

export const SAVE_OATT_MISC_CHARGE = gql`
  mutation SaveOattMiscCharge($invoiceId: Int!, $miscCharge: Float, $miscComment: String) {
    saveOattMiscCharge(invoiceId: $invoiceId, miscCharge: $miscCharge, miscComment: $miscComment) {
      success
      message
      invoice_id
    }
  }
`;

export const CREATE_OATT_BILLING_FORM = gql`
  mutation CreateOattBillingForm($month: Int!, $year: Int!, $customerId: Int) {
    createOattBillingForm(month: $month, year: $year, customerId: $customerId) {
      success
      message
      invoice_id
    }
  }
`;

export const LOG_OATT_INVOICE_DOWNLOAD = gql`
  mutation LogOattInvoiceDownload(
    $invoiceId: Int!
    $month: Int!
    $year: Int!
    $customerId: Int
  ) {
    logOattInvoiceDownload(
      invoiceId: $invoiceId
      month: $month
      year: $year
      customerId: $customerId
    )
  }
`;